module.exports = __webpack_public_path__ + "fonts/Roboto-100-vietnamese13.8b4f320.woff2";